import classNames from 'classnames/bind';
import React, { FunctionComponent } from 'react';
import styles from './embededded-video.module.scss';

const cx = classNames.bind(styles);

export interface IEmbeddedVideoProps {
  videoURL: string;
  width?: string;
  height?: string;
  allowFullscreen?: boolean;
  allowProperties?: string;
  justifyContent?: string;
  alignItems?: string;
}

export const EmbeddedVideo: FunctionComponent<IEmbeddedVideoProps> = props => {
  const {
    videoURL,
    width,
    height,
    allowProperties,
    allowFullscreen,
    justifyContent
  } = props;

  const classNames = cx(styles.videoWrapper, [`justify_${justifyContent}`]);
  return (
    <>
      <div className={classNames}>
        <iframe
          title="Blog video"
          src={videoURL}
          width={width}
          height={height}
          allow={allowProperties}
          allowFullScreen={allowFullscreen}
          className={styles.video}
        ></iframe>
      </div>
    </>
  );
};
